<template>
  <div class="home">
    <section>
      <div class="py-8 px-8">
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div>
            <h4 class="mb-0">{{ documentName }}</h4>
          </div>
          <div class="d-flex align-items-center gap-2 flex-grow-1 flex-md-grow-0">
            <div class="input-group" style="min-width: 240px; border-bottom: 1px solid #ddd;">
              <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="keyword" :placeholder="$t('search')">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="px-8">
      <invoice-component
        ref="processComponent"
        :keyword="keyword"
        documentMode="process"
        :documentTitle="documentName"
      />
    </section>
  </div>
</template>

<script>
import InvoiceComponent from '../../components/InvoiceComponent.vue'
import helper from '../../helper'

export default {
  name: 'Processes',
  persistedFilterState: { key: 'process-search', fields: ['keyword'] },
  components: { InvoiceComponent },
  data() {
    return { keyword: '' }
  },
  computed: {
    business() { return this.$store.getters.BUSINESS || {} },
    documentName() { return this.business?.metadata?.process_document_name || this.$t('default_process_name') }
  },
  mounted() {
    if (!helper.checkModuleIsEnabled('processes')) return this.$router.push({ path: '/' })
    if (helper.checkAccess('view_receipts') === -1) return this.$router.push({ path: '/' })
    if (helper.checkAccess('view_receipts') === -2) return this.$router.push({ path: '/subscribe' })
    if (this.$route.query.create === 'true') this.$nextTick(() => this.$refs.processComponent?.create())
  }
}
</script>
